export enum ROUTE_EVENT {
  ROUTE_FINISHED = 'ROUTE_FINISHED',
  ROUTE_STARTED = 'ROUTE_STARTED',
  ROUTE_OPENED = 'ROUTE_OPENED'
}
